import { createSlice } from "@reduxjs/toolkit";
import { getListRewardDataGw } from "../../api/rewardDataGw/rewardDataGw";

// giá trị khởi tạo của state
const initialState = {
  listRewardDataGw: [],
  isRewardDataGw: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API
};

const rewardDataGwSlice = createSlice({
  name: "rewardDataGw", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListRewardDataGw.pending, (state) => {
        state.isRewardDataGw = true;
        state.error = null;
      })
      .addCase(getListRewardDataGw.fulfilled, (state, action) => {
        state.isRewardDataGw = false;
        state.listRewardDataGw = action.payload.data || [];
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListRewardDataGw.rejected, (state, action) => {
        state.isRewardDataGw = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } =
  rewardDataGwSlice.actions;
export default rewardDataGwSlice.reducer;
